"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const Game_1 = require("./Game");
const Config_1 = require("./Config");
const ReplayPlayer_1 = require("./ReplayPlayer");
const index_1 = require("./PlayerInterface/index");
const FilePicker_1 = require("./FilePicker");
class HLV {
    constructor(game) {
        this.game = game;
    }
    load(name) {
        this.game.load(name);
    }
    loadFromPath(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.game.loadFromPath(filePath);
        });
    }
    loadMapFromPath(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.game.loader.loadMapFromPath(filePath);
        });
    }
    setTitle(title) {
        this.game.setTitle(title);
    }
    getTitle() {
        return this.game.getTitle();
    }
    showFilePicker() {
        (0, FilePicker_1.showFilePicker)();
    }
    get mapName() {
        return this.game.mapName;
    }
    setLocalResourceRoot(path) {
        this.game.setLocalResourceRoot(path);
    }
    loadReplayFromUrl(url, name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.game.loadReplayFromUrl(url, name || 'replay.rec');
        });
    }
    get hasLoadedReplay() {
        return !!this.game.player.replay;
    }
    addComparisonReplay(name, replay) {
        return this.game.addComparisonReplay(name, replay);
    }
    addComparisonReplayFromUrl(name, url) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.game.addComparisonReplayFromUrl(name, url);
        });
    }
    createReplayPlayer() {
        return new ReplayPlayer_1.ReplayPlayer(this.game);
    }
    removeComparisonReplay(entry) {
        this.game.removeComparisonReplay(entry);
    }
    clearComparisonReplays() {
        this.game.clearComparisonReplays();
    }
    setActiveReplay(index) {
        this.game.setActiveReplay(index);
    }
    resetComparisonReplays() {
        this.game.resetComparisonReplays();
    }
    onLoad(callback) {
        return this.game.events.on('load', callback);
    }
    enableFreeRoamComparison() {
        this.game.enableFreeRoamComparison();
    }
}
HLV.VERSION = VERSION;
var HLViewer;
(function (HLViewer) {
    function init(rootSelector, params) {
        const node = document.querySelector(rootSelector);
        if (!node) {
            return null;
        }
        const config = Config_1.Config.init(params);
        const result = Game_1.Game.init(config);
        if (result.status === 'success') {
            const game = result.game;
            const ui = new index_1.PlayerInterface(game, node);
            ui.draw();
            game.draw();
            const hlv = new HLV(game);
            if (typeof IS_TAURI !== 'undefined' && IS_TAURI) {
                (0, FilePicker_1.initFilePicker)(hlv);
            }
            return hlv;
        }
        return null;
    }
    HLViewer.init = init;
})(HLViewer || (HLViewer = {}));
module.exports = HLViewer;
